/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Same_All_HintInputs */

const en_us2_profile_editors_same_all_hint = /** @type {(inputs: Profile_Editors_Same_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan puts each workout on a weekday.`)
};

const pt_br2_profile_editors_same_all_hint = /** @type {(inputs: Profile_Editors_Same_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano marca cada treino num dia da semana.`)
};

const es_419_profile_editors_same_all_hint = /** @type {(inputs: Profile_Editors_Same_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El plan pone cada entrenamiento en un día de la semana.`)
};

const pt_pt2_profile_editors_same_all_hint = /** @type {(inputs: Profile_Editors_Same_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O plano marca cada treino num dia da semana.`)
};

const fr_fr2_profile_editors_same_all_hint = /** @type {(inputs: Profile_Editors_Same_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le programme place chaque séance sur un jour de la semaine.`)
};

const de_de2_profile_editors_same_all_hint = /** @type {(inputs: Profile_Editors_Same_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Plan legt jedes Training auf einen Wochentag.`)
};

const it_it2_profile_editors_same_all_hint = /** @type {(inputs: Profile_Editors_Same_All_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda assegna ogni allenamento a un giorno della settimana.`)
};

/**
* | output |
* | --- |
* | "The plan puts each workout on a weekday." |
*
* @param {Profile_Editors_Same_All_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_same_all_hint = /** @type {((inputs?: Profile_Editors_Same_All_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Same_All_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_same_all_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_same_all_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_same_all_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_same_all_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_same_all_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_same_all_hint(inputs)
	return en_us2_profile_editors_same_all_hint(inputs)
});
export { profile_editors_same_all_hint as "profile-editors.same_all_hint" }